(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','$http', '$scope', '$state', '$timeout'];

    function PasswordController (Auth, Principal, $http, $scope, $state, $timeout) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.doNotMatchPass =null;
        vm.error = null;
        vm.success = null;
        vm.login=null;
        vm.oldnew=false;
        $scope.showSave = true;
       var randmnum=0;
        Principal.identity().then(function(account) {
            vm.account = account;
            vm.login=account.login;
   
        });

/*        function changePassword () {
        	 var url = 'api/account/old_password';
        	 var fd=new FormData();
        	 randmnum=Math.random();
        	 var password=Auth.encryptPassword(vm.oldPassword+"_"+randmnum);
        	 
        	 var user = 
             {
                 newPassword: password,
                 passCheck: randmnum
              };
        	 $http.post(url,user).then(function(response) {
        		 vm.oldnew=false;
        		 if (vm.password !== vm.confirmPassword) {
                     vm.error = null;
                     vm.success = null;
                     vm.doNotMatchPass =null;
                     vm.showSave = false;
                     vm.doNotMatch = 'ERROR';
                     
                     $timeout(function() {
                      	  
                      	  vm.doNotMatch ="";

							}, 3000);

                } else if(vm.password !==vm.oldPassword ){
                     vm.doNotMatch = null;
                     randmnum=Math.random();
                     var password=Auth.encryptPassword(vm.password+"_"+randmnum);
                     Auth.changePassword({newPassword:password,passCheck:randmnum}).then(function (response) {
                         vm.error = null;
                         vm.doNotMatchPass =null;
                          vm.success = 'OK';
                          $scope.showSave = false;
                          $timeout(function() {
                        	  
                        	  vm.success ="";
                        	  
							}, 3000);


                     })["catch"](function (response) {
                    	 vm.username=false;
                         vm.pattern=false;
                         vm.isLastFivePassword=false;
                    	 if(response.data==='Username should not be in password'){
                    		 vm.username=true;
                    		 $timeout(function() {
                              	  
                              	  vm.username =false;

      							}, 3000);
                    	 }else if(response.data==='Invalid password format'){
                             vm.pattern=true;
                             $timeout(function() {
                             	  
                             	  vm.pattern =false;

     							}, 3000);
                    	 }else if(response.data==='Password cannot be from last 5 passwords'){
                             vm.isLastFivePassword=true;
                             $timeout(function() {
                           	  
                           	  vm.isLastFivePassword =false;

   							}, 3000);

                         }else{
                    		 vm.success = null;
                             vm.doNotMatchPass =null;
                             vm.doNotMatch = null;
                             vm.error = 'ERROR';
                             
                             $timeout(function() {
                            	  
                            	  vm.error ="";

    							}, 3000);
                    	 }
                     });
                 }else{
                	 vm.oldnew=true;
                 }
        	
        	
        	 })["catch"](function (response) {
                 vm.success = null;
                 vm.error = null;
                 vm.doNotMatchPass = 'ERROR';
                 $timeout(function() {
               	  
               	  vm.doNotMatchPass ="";

					}, 3000);
             });
        }*/
        
        
        function changePassword () {
       	 var url = 'api/account/change_password_old';
       	 var fd=new FormData();
       	 randmnum=Math.random();
       	 var oldPassword=Auth.encryptPassword(vm.oldPassword+"_"+randmnum);
       	 var newPassword=Auth.encryptPassword(vm.password+"_"+randmnum);
       	 var user = 
            {
       			oldPassword: oldPassword,
       			newPassword : newPassword,
                passCheck: randmnum
             };
       	
       	 
       if (vm.password !== vm.confirmPassword) {
            vm.error = null;
            vm.success = null;
            vm.doNotMatchPass =null;
            vm.showSave = false;
            vm.doNotMatch = 'ERROR';
            
            $timeout(function() {
             	  
             	  vm.doNotMatch ="";

					}, 3000);

       } else if(vm.password !==vm.oldPassword ){
            vm.doNotMatch = null;
            vm.oldnew=false;
            $http.post(url,user).then(function(response) {
            	vm.error = null;
                vm.doNotMatchPass =null;
                vm.success = 'OK';
                $scope.showSave = false;
                $timeout(function() {
               	  
               	  vm.success ="";
               	  
					}, 3000);
          		 
          	
          	
          	 })["catch"](function (response) {
               	 vm.username=false;
                 vm.pattern=false;
                 vm.isLastFivePassword=false;
            	 if(response.data==='Username should not be in password'){
            		 vm.username=true;
            		 $timeout(function() {
                      	  
                      	  vm.username =false;

 							}, 3000);
            	 }else if(response.data==='Invalid password format'){
                     vm.pattern=true;
                     $timeout(function() {
                     	  
                     	  vm.pattern =false;

 						}, 3000);
            	 }else if(response.data==='Password cannot be from last 5 passwords'){
                     vm.isLastFivePassword=true;
                     $timeout(function() {
                   	  
                   	  vm.isLastFivePassword =false;

 						}, 3000);

                 }else if(response.data==='old password is not Match'){
                	 vm.success = null;
                     vm.error = null;
                     vm.doNotMatchPass = 'ERROR';
                     $timeout(function() {
                   	  
                   	  vm.doNotMatchPass ="";

    					}, 3000);

                 }else{
            		 vm.success = null;
                     vm.doNotMatchPass =null;
                     vm.doNotMatch = null;
                     vm.error = 'ERROR';
                     vm.oldnew=true;
                     
                     $timeout(function() {
                    	  
                    	  vm.error ="";

 						}, 3000);
            	 }
               });
        }else{
       	 vm.oldnew=true;
        }       	
       }
        
        $scope.close = function(){
        	Auth.logout();
        	$state.go('login');
        }
    }
})();